import { useMemo } from "react";
import { REFERRAL_BANNER_CONSTANTS } from "./ReferralBanner.constants";
import { getInitials } from "./ReferralBanner.utils";

export const useReferralBanner = ({ referralOverview, referralsList }) => {
  const { FRIENDS_CARD } = REFERRAL_BANNER_CONSTANTS;

  // Commission rate from overview
  const commissionRate =
    referralOverview?.commission_rate ?? FRIENDS_CARD.DEFAULT_RATE;

  // Converted / joined count from referralOverview or list
  const joinedCount = useMemo(() => {
    if (
      referralOverview?.converted_referrals !== null &&
      referralOverview?.converted_referrals !== undefined
    ) {
      return Number(referralOverview.converted_referrals);
    }
    if (
      referralOverview?.total_referrals !== null &&
      referralOverview?.total_referrals !== undefined
    ) {
      return Number(referralOverview.total_referrals);
    }
    if (Array.isArray(referralsList)) {
      const converted = referralsList.filter(
        (r) =>
          Number(r?.status) === FRIENDS_CARD.CONVERTED_STATUS ||
          r?.status === String(FRIENDS_CARD.CONVERTED_STATUS)
      );
      return converted.length;
    }
    return 0;
  }, [referralOverview, referralsList, FRIENDS_CARD.CONVERTED_STATUS]);

  // Avatars extracted from referralsList or generated for joinedCount
  const avatars = useMemo(() => {
    if (Array.isArray(referralsList) && referralsList.length > 0) {
      return referralsList
        .slice(0, FRIENDS_CARD.MAX_VISIBLE_AVATARS)
        .map((item, idx) => ({
          id: item?.id || item?.uuid || `avatar-${idx}`,
          initials: getInitials(item),
          colorClass:
            FRIENDS_CARD.COLOR_PALETTES[
              idx % FRIENDS_CARD.COLOR_PALETTES.length
            ],
        }));
    }

    if (joinedCount > 0) {
      return FRIENDS_CARD.FALLBACK_INITIALS.slice(
        0,
        Math.min(joinedCount, FRIENDS_CARD.MAX_VISIBLE_AVATARS)
      ).map((text, idx) => ({
        id: `fallback-avatar-${idx}`,
        initials: text,
        colorClass:
          FRIENDS_CARD.COLOR_PALETTES[idx % FRIENDS_CARD.COLOR_PALETTES.length],
      }));
    }

    return [];
  }, [
    referralsList,
    joinedCount,
    FRIENDS_CARD.MAX_VISIBLE_AVATARS,
    FRIENDS_CARD.COLOR_PALETTES,
    FRIENDS_CARD.FALLBACK_INITIALS,
  ]);

  const friendsJoinedText =
    joinedCount === FRIENDS_CARD.SINGLE_FRIEND_COUNT
      ? `${joinedCount} ${FRIENDS_CARD.SINGULAR_TEXT}`
      : `${joinedCount} ${FRIENDS_CARD.PLURAL_TEXT}`;

  return {
    commissionRate,
    joinedCount,
    avatars,
    friendsJoinedText,
  };
};
